Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/org_slack_restrictions'

module.exports = class OrganizationRestrictSlackLinkingView extends View
  viewTitleKey: 'slack team restrictions'

  initialize: ->
    @listenTo @model, 'change:slack-association', @render

  events:
    'click a': 'setRestriction'

  render: ->
    data = @model._slackAssociation

    @$el.html template(data)

    @

  setRestriction: (e) ->
    Util.stop(e)

    if e.target.parentElement.classList.contains('active')
      return
    else
      enableAdminOnly = e.target.parentElement.classList.contains('js-enable-admin-only')
      @model.changeSlackAdminOnlyLinking(enableAdminOnly)
    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-restrict-slack-linking-view.coffee